var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_24772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.62505 1.72046H14.4028C15.2849 1.72046 16 2.48664 16 3.43177V14.3841C16 15.3293 15.2849 16.0954 14.4028 16.0954H1.62505C0.742932 16.0954 0.027832 15.3293 0.027832 14.3841V3.43177C0.027832 2.48664 0.742932 1.72046 1.62505 1.72046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.79 7.63208H2.40812C1.74653 7.63208 1.21021 8.20671 1.21021 8.91556V10.0279H4.87246C5.08426 10.0279 5.28739 10.1181 5.43716 10.2785L6.23577 11.1342C6.59734 11.5216 7.08774 11.7392 7.59908 11.7392C8.11042 11.7392 8.60082 11.5216 8.9624 11.1342L9.76101 10.2785C9.91077 10.1181 10.1139 10.0279 10.3257 10.0279H13.988V8.91556C13.988 8.20671 13.4516 7.63208 12.79 7.63208Z",
    fill: "#328CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82291 0.0090332C2.16132 0.0090332 1.625 0.583667 1.625 1.29251V5.14295H14.4028V1.29251C14.4028 0.583667 13.8664 0.0090332 13.2048 0.0090332H2.82291Z",
    fill: "#328CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75513 3.43164C0.957445 3.43164 0.310791 4.00627 0.310791 4.71512V7.19652H15.7171V4.71512C15.7171 4.00627 15.0705 3.43164 14.2728 3.43164H1.75513Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_24772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.c0d9c231f8ba1a3b787843b000571467.svg";
export { ForwardRef as ReactComponent };